import { Loader } from "@googlemaps/js-api-loader";
export default new Loader({
  apiKey: process.env.API_KEY,
});
